import { Flex } from "@chakra-ui/react";
import { LoanTypes } from "./loan-types/loan-types";
import { Sections } from "./sections/sections";

export function FieldSettingsWithSections() {
	return (
		<Flex direction="column" gap={8}>
			<Sections />
			<LoanTypes />
		</Flex>
	);
}
